import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const BuildingIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 15, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 15) / 15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.21429 6.01609C3.21429 5.72438 3.45375 5.48763 3.75 5.48763H6.96429C7.26054 5.48763 7.5 5.72438 7.5 6.01609C7.5 6.3078 7.26054 6.54456 6.96429 6.54456H3.75C3.45375 6.54456 3.21429 6.3078 3.21429 6.01609ZM6.96429 7.60149H3.75C3.45375 7.60149 3.21429 7.83824 3.21429 8.12995C3.21429 8.42167 3.45375 8.65842 3.75 8.65842H6.96429C7.26054 8.65842 7.5 8.42167 7.5 8.12995C7.5 7.83824 7.26054 7.60149 6.96429 7.60149ZM6.96429 9.71535H3.75C3.45375 9.71535 3.21429 9.9521 3.21429 10.2438C3.21429 10.5355 3.45375 10.7723 3.75 10.7723H6.96429C7.26054 10.7723 7.5 10.5355 7.5 10.2438C7.5 9.9521 7.26054 9.71535 6.96429 9.71535ZM6.96429 11.8292H3.75C3.45375 11.8292 3.21429 12.066 3.21429 12.3577C3.21429 12.6494 3.45375 12.8861 3.75 12.8861H6.96429C7.26054 12.8861 7.5 12.6494 7.5 12.3577C7.5 12.066 7.26054 11.8292 6.96429 11.8292ZM15 14.4715C15 14.7632 14.7605 15 14.4643 15H0.535714C0.239464 15 0 14.7632 0 14.4715C0 14.1798 0.239464 13.9431 0.535714 13.9431H1.07143V4.22882C1.07143 3.8256 1.29857 3.4636 1.66339 3.2834L8.09196 0.112605C8.42732 -0.0522761 8.81625 -0.0353652 9.13446 0.158582C9.45268 0.352528 9.64232 0.688632 9.64232 1.05803V4.95916H12.8566C13.4475 4.95916 13.928 5.43319 13.928 6.01609V13.9431H14.4637C14.76 13.9431 15 14.1798 15 14.4715ZM9.64286 6.01609V13.9431H12.8571V6.01609H9.64286ZM2.14286 13.9431H8.57143V1.05803L2.14286 4.22882V13.9431Z"
        fill="currentColor"
      />
    </svg>
  )
})
BuildingIcon.displayName = 'BuildingIcon'
